/* ==========================================================================
   LUNDRA — En-tête : état au défilement, ligne de progression,
   sélecteur de langue, compteur du panier, ancres.
   Aucune dépendance.
   ========================================================================== */
(function () {
  'use strict';

  var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initEntete() {
    var entete = document.querySelector('[data-lu-entete]');
    if (!entete) return;

    var progres = entete.querySelector('[data-lu-progres]');
    var tick = false;

    function mesurer() {
      tick = false;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      entete.classList.toggle('est-defile', y > 8);

      if (progres) {
        var doc = document.documentElement;
        var total = (doc.scrollHeight - window.innerHeight);
        var part = total > 0 ? Math.min(1, Math.max(0, y / total)) : 0;
        progres.style.transform = 'scaleX(' + part.toFixed(4) + ')';
      }
    }

    function auDefilement() {
      if (tick) return;
      tick = true;
      window.requestAnimationFrame(mesurer);
    }

    window.addEventListener('scroll', auDefilement, { passive: true });
    window.addEventListener('resize', auDefilement, { passive: true });
    mesurer();
  }

  /* Le sélecteur de langue envoie le formulaire natif de Shopify.
     Le choix est mémorisé : la bascule automatique ne le contredira plus. */
  function initLangue() {
    document.querySelectorAll('[data-lu-langue]').forEach(function (form) {
      var select = form.querySelector('select');
      if (!select || select.dataset.luPret) return;
      select.dataset.luPret = '1';
      select.addEventListener('change', function () {
        try { localStorage.setItem('lu-langue', select.value); } catch (e) {}
        form.submit();
      });
    });
  }

  /* Garde le compteur du panier juste, y compris après un retour arrière
     depuis une page mise en cache par le navigateur. */
  function rafraichirPanier() {
    var lien = document.querySelector('[data-lu-panier]');
    if (!lien || !window.Shopify || !window.Shopify.routes) return;
    fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (panier) {
        if (!panier) return;
        var compte = lien.querySelector('[data-lu-panier-compte]');
        if (compte) compte.textContent = panier.item_count;
        lien.classList.toggle('lundra-entete__panier--vide', panier.item_count === 0);
      })
      .catch(function () { /* on garde la valeur rendue par Liquid */ });
  }

  /* Ancres : défilement doux quand la cible est sur la page affichée,
     et mise en avant du lien dont la section est à l'écran. */
  function initAncres() {
    var liens = document.querySelectorAll('.lundra-entete__lien[href*="#"]');
    if (!liens.length) return;

    var parAncre = {};

    liens.forEach(function (a) {
      var url;
      try { url = new URL(a.getAttribute('href'), window.location.href); }
      catch (e) { return; }
      if (!url.hash || url.pathname !== window.location.pathname) return;

      var id = decodeURIComponent(url.hash.slice(1));
      var cible = document.getElementById(id);
      if (!cible) return;

      parAncre[id] = a;
      a.addEventListener('click', function (evt) {
        evt.preventDefault();
        cible.scrollIntoView({ behavior: reduit ? 'auto' : 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + id);
      });
    });

    if (reduit || !('IntersectionObserver' in window)) return;

    var obs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        var lien = parAncre[e.target.id];
        if (!lien) return;
        lien.style.setProperty('color', e.isIntersecting ? 'var(--lu-encre)' : '');
      });
    }, { rootMargin: '-45% 0px -45% 0px' });

    Object.keys(parAncre).forEach(function (id) {
      var cible = document.getElementById(id);
      if (cible) obs.observe(cible);
    });
  }

  function demarrer() {
    initEntete();
    initLangue();
    initAncres();
    rafraichirPanier();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  window.addEventListener('pageshow', function (e) { if (e.persisted) rafraichirPanier(); });
  document.addEventListener('shopify:section:load', demarrer);
})();
